module.exports = __webpack_public_path__ + "img/机房设备.b6f79431.gif";